import 'bootstrap-icons/font/bootstrap-icons.min.css'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './app/App'
import reportWebVitals from './app/reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import moment from 'moment'
import 'moment/locale/vi'

// setup
moment().locale('vi')

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
